import { render, staticRenderFns } from "./BreaksNotification.vue?vue&type=template&id=26f7a334&"
import script from "./BreaksNotification.vue?vue&type=script&lang=js&"
export * from "./BreaksNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports